export const arabicCoords = (width, nameWidth, courseWidth, height) => {
    
    let courseFont = 14;

    let nameX = (width / 2) - (nameWidth / 2)
  
    let courseX = (width / 2) - (courseWidth / 2)
  
    
    if (courseWidth > 500) {
        courseFont = 12;
      }
    
    return {
        'nameX': nameX,
        'nameY': height - 200,

        'courseX': courseX,
        'courseY': 255,
  
        'startDateX': 270,
        'startDateY': 220,
  
        'endDateX': 140,
        'endDateY': 220,
  
        'hoursX': 310,
        'hoursY': 183,

        'courseFont': courseFont
    }
}


export const englishCoords = (width, nameWidth, courseWidth, height) => {
    
  let courseFont = 14;

  let nameX = (width / 2) - (nameWidth / 2)
  
  let courseX = (width / 2) - (courseWidth / 2)

  if (courseWidth > 500) {
      courseFont = 12;}
  
  return {
      'nameX': nameX,
      'nameY': height - 200,

      'courseX': courseX,
      'courseY': 270,

      'startDateX': 278,
      'startDateY': 225,

      'endDateX': 413,
      'endDateY': 225,

      'hoursX': 310,
      'hoursY': 183,

      'courseFont': courseFont
  }

}